var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0001 20C38.0001 29.9411 29.9413 38 20.0001 38C10.059 38 3.5 30.5 2.00014 20C0.594382 10.1588 10.059 2 20.0001 2C29.9413 2 38.0001 7.5 38.0001 20Z",
    fill: "#F7D06F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.9412C22.4495 12.0953 20.6367 11.6478 18.2538 11.6902C16.3266 11.7245 14.9167 13.4256 14.9167 15.3531V15.3531C14.9167 17.2286 16.2533 18.8377 18.0969 19.1819L19.9583 19.5294L21.1031 19.7431C23.3622 20.1648 25 22.1367 25 24.4349V24.4349C25 26.5492 23.6202 28.5132 21.5211 28.767C18.6744 29.1112 16.7216 28.4543 14 27.0588",
    stroke: "#57455D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9C18.7711 17.5026 19.5 23 18 31",
    stroke: "#57455D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIcon);
export default __webpack_public_path__ + "static/media/pricing-icon.c9fd17a9fdea6e20c1ca65b7d0bff84f.svg";
export { ForwardRef as ReactComponent };